import { fetchUnifiedProfile, X_TRANSFER_KEY } from '@/services'
import md5 from 'md5'
import { saveButtonAuth } from 'shj-utils'
import config from '@/layouts/config'
import microApp, {
  getActiveApps,
  // removeDomScope,
  // unmountAllApps,
  // unmountApp,
} from '@micro-zoe/micro-app'
// import { useLocation, useNavigate } from 'react-router-dom'

import { cloneDeep, set } from 'lodash-es'
import global from '@/utils/global.ts'
import { triggerEvent } from '@/utils/customEvent.ts'
import SIPCall from "@/utils/sip/sip_call.ts";

export const tokenKey = 'token'

export function saveUser() {
  return localStorage.getItem('user')
}

export function getTenantId() {
  return localStorage.getItem('X-Transfer-Inside-Tenant-Id')
}

export function getUserCurrentCompanyCode() {
  return getUser()?.primaryDepartPosition?.companyCode
}

export function getUser() {
  const userStr = localStorage.getItem('user')
  const userExtendStr = localStorage.getItem('userExtend')
  let user: any = null
  try {
    if (userStr && userStr !== 'undefined') {
      user = JSON.parse(userStr)
      if (user && userExtendStr && userExtendStr !== 'undefined') {
        user.extend = JSON.parse(userExtendStr)
        set(user, 'currentRoles[0].dataLevel', user.extend.dataScope)
      }
    }
  } catch (err) {
    console.log(err)
  }

  return user
}

export function getUserExtend() {
  const userExtendStr = localStorage.getItem('userExtend')
  let userExtend: any = null
  try {
    if (userExtendStr && userExtendStr !== 'undefined') {
      userExtend = JSON.parse(userExtendStr)
    }
  } catch (err) {
    console.log(err)
  }

  return userExtend
}

/**
 * 深度优先搜索
 * @param children
 * @param cb
 * @param opts
 * @returns
 */

export function dfs(
  children: any[],
  cb: (item: any, level: number) => any,
  { level = 0, childrenKey = 'children' }: any = {}
) {
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      let isBreak = cb && cb(children[i], level)
      if (isBreak) return isBreak
      if (children[i] && children[i][childrenKey]) {
        isBreak = dfs(children[i][childrenKey], cb, {
          level: level + 1,
          childrenKey,
        })
      }
      if (isBreak) return isBreak
    }
  }
  return false
}

export function getTokenExpireDate() {
  return localStorage.getItem('tokenExpireDate')
}

export function getMenuList() {
  return localStorage.getItem('menuList')
}

export function getTokenExpire() {
  // return localStorage.getItem('tokenExpireDate')
  return localStorage.getItem('expireAt')
}

export function isTokenExpire() {
  const now = Date.now()
  const tokenExpire = getTokenExpire() || ''
  return now >= parseInt(tokenExpire) - 5000
}

export function getLocalTabList() {
  // return localStorage.getItem('tokenExpireDate')
  return localStorage.getItem('tabList')
}

export function setLocalTabList(tabList?: any) {
  // return localStorage.getItem('tokenExpireDate')
  localStorage.setItem('tabList', JSON.stringify(tabList))
}

export function getLocalTenants() {
  return localStorage.getItem('tenants')
}

export function setLocalTenants(tenants: any) {
  return localStorage.setItem('tenants', JSON.stringify(tenants))
}

export function getLocalCheckInfo() {
  return localStorage.getItem('checkInfo')
}

export function getToken() {
  if (typeof window === 'undefined') {
    return ''
  }
  let tokenStr =
    window.localStorage.getItem(tokenKey) || window.localStorage.getItem('__token') || ''

  try {
    tokenStr = JSON.parse(tokenStr)
    if (!tokenStr.startsWith('Bearer')) {
      tokenStr = 'Bearer ' + tokenStr
    }
  } catch (e) {
    return tokenStr
  }
  return tokenStr
}

export function getRefreshToken() {
  return localStorage.getItem('refreshToken')
}

export const saveToken = (token: string, expireDate?: string) => {
  localStorage.setItem(tokenKey, JSON.stringify(token))
  if (expireDate) localStorage.setItem('tokenExpireDate', expireDate)
}

export const userChangeRemoveStore = () => {
  const removeKeys = localStorage.getItem('USER_CHANGE_REMOVE_KEYS')

  if (removeKeys) {
    const removes = removeKeys.split(',')
    removes.map(key => localStorage.removeItem(key))
  }
}

export const onLogout = (pathname?: string) => {
  // console.log('unmountAllApps:', globalState.unmountAllApps)
  // if (globalState.unmountAllApps) {
  //   globalState.unmountAllApps({ clearAliveState: true });
  // }

  if (microApp) {
    const globalData: any = microApp.getGlobalData()
    globalData?.beforeLogout?.()

    microApp.clearGlobalData()

    microApp?.unmountAllApps?.({ destroy: true })
    // setTimeout(() => {
    //   microApp?.unmountAllApps?.({ destroy: true })
    // }, 20)
  }

  // for (const key in localStorage) {
  //   localStorage.removeItem(key)
  // }
  triggerEvent('STORE_CLEAR')

  userChangeRemoveStore()
  localStorage.removeItem('__token')
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  localStorage.removeItem('userInfos')
  localStorage.removeItem('buttonAuth')
  localStorage.removeItem('tokenExpireDate')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('userExtend')
  localStorage.removeItem('menuList')
  localStorage.removeItem('ANTD_CONFIG_PROVIDER')
  localStorage.removeItem(X_TRANSFER_KEY)
  localStorage.removeItem('tenants')
  localStorage.removeItem('paramAuth')
  sessionStorage.removeItem('_all_menu')
  sessionStorage.removeItem('tabList')

  setTimeout(() => {
    sessionStorage.clear()
    if (pathname) {
      sessionStorage.setItem('LOGOUT_PATH', pathname)
    }
  }, 10)

  global.menu = []
  // if (AnalysysAgent) {
  //   AnalysysAgent.clearSuperProperties();
  // }
}

export const resolveResponse = response => {
  if (response.config.raw) return response
  return response.data.data ?? response.data
}

export const onTokenOverdue = () => {
  onLogout()
}

export const isLogin = () => {
  return !!getToken()
}

export const getUserInfo = () => {
  const { menuList } = config
  return fetchUnifiedProfile().then((res: any) => {
    const user = res?.data?.data
    if (res?.data) {
      localStorage.setItem(
        'user',
        JSON.stringify(user ? { ...user, workNumber: user.workerNumber } : user)
      )
      localStorage.setItem('userId', md5(res?.data?.data?.workNumber))
      localStorage.setItem('menuList', JSON.stringify(menuList))
      saveButtonAuth(res?.data?.data?.buttonList)
      // let path = sessionStorage.getItem('LOGOUT_PATH') || '/'
      // sessionStorage.removeItem(COUNT_DOWN_KEY);
    }
    return res
  })
}

/**
 * 对数据进行扁平化处理
 * @param arr
 * @returns
 */
export const treeToOneArr = (arr?: any[]) => {
  try {
    const data = cloneDeep(arr) // 对传入的参数进行深拷贝
    const newData: any[] = [] // 创建空数组用来接收操作后的新数组
    const hasChildren = (item: any) => {
      // 递归遍历，把包含children的选项拿出来，push到之前新建的空数组内
      ;(item.children || (item.children = [])).map?.((v: any) => {
        hasChildren(v)
      })
      // delete item.children // 删除原children属性，可选项
      newData.push(item)
    }
    data.map((v: any) => hasChildren(v))
    return newData
  } catch (err) {
    return []
  }
}

/**
 * 对虚拟路由进行解析
 * @param arr
 * @returns
 */
export const findRealUrl = (arr?: any[], path?: string, pathName?: string) => {
  let list = treeToOneArr(arr)
  // console.log(path, pathName);

  let url = decodeURIComponent(path).split('/').filter(Boolean)

  let newUrl = url.join('/')
  let findMenu = list.find(item => {
    if (
      item?.path == '$' + path ||
      item?.apppath + item?.path == '/' + newUrl ||
      item?.path == '$' + path + '/' ||
      item?.path + '/' == '$' + path
    ) {
      return item
    }
  })

  return findMenu
}

export function findAllPath(
  target: number | string | object,
  children: any,
  { childrenKey, compare, key = '' }: any = {}
) {
  let targetVal: string =
    typeof target === 'string' || typeof target === 'number' ? target : target[key || 'id' || 'key']

  // 将所有可能的key值存下，后续作判断
  let likelyKeys: any[] = []
  if (!key && typeof target === 'object') {
    for (const key in target) {
      likelyKeys.push(key)
    }
  }

  if (!compare) {
    compare = function (item: any) {
      if (targetVal) {
        return [item[key], item.id, item.key].includes(targetVal)
      }
      for (const likelyKey of likelyKeys) {
        if (item[likelyKey] === target[likelyKey]) {
          return true
        }
      }
    }
  }

  let path: any[] = []
  let isFind = false

  dfs(
    children,
    (item: any, level: number) => {
      if (!isFind) {
        path = path.slice(0, level)
        path[level] = item
      }

      if (compare(item)) {
        isFind = true
        return isFind
      }
    },
    { childrenKey }
  )
  return isFind ? path : []
}

export const getTreeList = (rootList, pid, newArr) => {
  for (const item of rootList) {
    if (item.pid === pid) {
      newArr.push(item)
    }
  }
  //给数组里面再添加一个children的空数组
  for (const i of newArr) {
    i.children = []
    getTreeList(rootList, i.nid, i.children)

    if (i.children.length == 0) {
      delete i.children
    }
  }
  return newArr
}

export const queryURLParams = url => {
  let askIn = url.indexOf('?'),
    wellIn = url.indexOf('#'),
    askText = '',
    wellText = ''
  // #不存在
  wellIn === -1 ? (wellIn = url.length) : null
  // ?存在
  askIn >= 0 ? (askText = url.substring(askIn + 1, wellIn)) : null
  wellText = url.substring(wellIn + 1)
  let result = {}
  wellText !== '' ? (result['HASH'] = wellText) : null
  if (askText !== '') {
    let ary = askText.split('&')
    ary.forEach(item => {
      let aryText = item.split('=')
      result[aryText[0]] = aryText[1]
    })
  }
  return result
}

//统一的路由跳转判断 appPath 子应用名称 path 子应用路径
export const navigatePage = (
  appPath?: string,
  path?: string,
  fn?: any,
  state?: any,
  search?: string
) => {
  // console.log('navigatePage', appPath, path)
  let realAppPath = appPath?.replace('/', '')
  let realPath = ''
  let list = path.split('/').filter(Boolean)
  let activeApps = getActiveApps({ excludeHiddenApp: true })
  let replace = false
  let realSearch = search ? search : ''
  // if (/^\$/g.test(menuPath)) {s
  //   menuPath = menuPath.replace(/^\$/g, '/');
  // }

  // if(realAppPath == 'main'){
  //   fn(path);
  //   return;
  // }
  let crossMicroApp = false
  if (list[0] == '$') {
    list.shift()
    realAppPath = list[0]
    list.shift()
    let newUrl = list.join('/')
    realPath = '/' + newUrl
    crossMicroApp = true
  } else {
    realAppPath = realAppPath
    realPath = path
  }

  if (appPath === '/' && !crossMicroApp) {
    fn(realAppPath + realPath + realSearch, {
      // replace
    })
  } else if (activeApps.includes(realAppPath)) {
    microApp.router.push({ name: realAppPath, path: '/' + realAppPath + realPath + realSearch })
  } else {
    replace = true
    fn('/' + realAppPath + realPath + realSearch, {
      // replace
    })
    setTimeout(() => {
      microApp.router.push({
        name: realAppPath,
        path: '/' + realAppPath + realPath + realSearch,
        replace,
      })
      // microApp.router.attachToURL(realAppPath)
    }, 0)
  }

  // setTimeout(() => {
  // microApp.forceSetData(realAppPath, {
  //   path: realPath,
  //   pathName: '/' + realAppPath,
  //   state,
  //   search,
  //   replace,
  // })
  // }, 16)
}

export const getLikelyPath = (pathname: any) => {
  let likelySysKey
  let likelyPath
  if (pathname) {
    let _pathArr = pathname.split('/').filter((path: any) => !!path)
    likelySysKey = _pathArr.shift()
    likelyPath = '/' + _pathArr.join('/')
  }
  return [likelyPath, likelySysKey]
}
